import { SearchProviderRedux } from 'types/SearchProvider'

export const SearchProviderActionConstants = {
  UPDATE_SEARCH_PROVIDER: 'UPDATE_SEARCH_PROVIDER_STORE',
}

export type SearchProviderReduxAction = {
  type: typeof SearchProviderActionConstants.UPDATE_SEARCH_PROVIDER
  payload: Partial<SearchProviderRedux>
}

export const SearchProviderActions = {
  UPDATE_SEARCH_PROVIDER: (payload: Partial<SearchProviderRedux>): SearchProviderReduxAction => ({
    type: SearchProviderActionConstants.UPDATE_SEARCH_PROVIDER,
    payload,
  }),
}
